import { render, staticRenderFns } from "./ActiveGames.vue?vue&type=template&id=78c4a548&scoped=true&"
import script from "./ActiveGames.vue?vue&type=script&lang=js&"
export * from "./ActiveGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4a548",
  null
  
)

export default component.exports